module.exports = __webpack_public_path__ + "static/media/cover.84df2be5.png";